export enum BriefOutcome {
  OUTCOME_TRUE_REVISION_UP = 1001,
  OUTCOME_TRUE_REVISION_DOWN = 1002,
  OUTCOME_TRUE_90D_HIGH = 1001,
  OUTCOME_TRUE_90D_LOW = 1002,
  OUTCOME_TRUE_REVENUE_UPGRADE = 1001,
  OUTCOME_TRUE_REVENUE_DOWNGRADE = 1002,
  OUTCOME_TRUE_EPS_UPGRADE = 1003,
  OUTCOME_TRUE_EPS_DOWNGRADE = 1004,
  OUTCOME_TRUE_MIXED_REVISION = 1005,
  OUTCOME_TRUE_INSIDER_BUY = 1001,
  OUTCOME_TRUE_INSIDER_SELL = 1002,
  OUTCOME_TRUE_PRICE_MOVE_UP = 1001,
  OUTCOME_TRUE_PRICE_MOVE_DOWN = 1002,
  OUTCOME_TRUE_NO_MISALIGNMENT = 1001,
  OUTCOME_TRUE_EPS_MISALIGNMENT = 1002,
  OUTCOME_TRUE_REVENUE_MISALIGNMENT = 1003,
  OUTCOME_TRUE_POSITIVE_RESULT = 1001,
  OUTCOME_TRUE_NEUTRAL_RESULT = 1002,
  OUTCOME_TRUE_NEGATIVE_RESULT = 1003,
  OUTCOME_TRUE_BREAK_EVEN_GOOD = 1001,
  OUTCOME_TRUE_BREAK_EVEN_BAD = 1002,
}

export enum BriefType {
  HasUpcomingDividend = 'HasUpcomingDividend',
  IsNew90DayHighLow = 'IsNew90DayHighLow',
  HasPriceTargetChanged = 'HasPriceTargetChanged',
  HasReportedEarnings = 'HasReportedEarnings',
  HasMajorEstimateRevision = 'HasMajorEstimateRevision',
  HasRecentInsiderTransactions = 'HasRecentInsiderTransactions',
  ValuationUpdateWith7DayPriceMove = 'ValuationUpdateWith7DayPriceMove',
  AnalystEstimateSurprisePostEarnings = 'AnalystEstimateSurprisePostEarnings',
  HasRecentInsiderTransactionsDerivative = 'HasRecentInsiderTransactionsDerivative',
  HasExecutiveDeparture = 'HasExecutiveDeparture',
  HasBreakevenDateChange = 'HasBreakevenDateChange',
  BoardChange = 'BoardChange',
  HasDirectorOverboarding = 'HasDirectorOverboarding',
  BuyingOpportunity = 'BuyingOpportunity',
}

export type BriefColorVariants = 'good' | 'bad' | 'neutral' | 'default';
